import { render, staticRenderFns } from "./com.vue?vue&type=template&id=3062b4d4&scoped=true&"
import script from "./com.vue?vue&type=script&lang=js&"
export * from "./com.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3062b4d4",
  null
  
)

export default component.exports